import DataProcessingConsents from './DataProcessingConsents';

export default DataProcessingConsents;
